import { put, call, takeLatest } from 'redux-saga/effects';
import { SYSTEM } from '../constants';
import * as actions from '../actions';
import { queryGroup } from '../api';

export default function* watchAccount() {
    yield takeLatest(SYSTEM.GROUP_QUERY, systemSaga)
}

export function* systemSaga(action) {
    try {
        yield put(actions.queryLoad());
        const resultJson = yield call(queryGroup, action.formData);
        const token = "";//resultJson.token;
        const result = resultJson.result;
        yield put(actions.querySuccess(token, result));
    } catch (error) {
        console.error(error);
    }
}